import React from 'react';
import { Layout, Flex } from 'app/components/base/Layout';
import Button from 'app/components/base/Button';
import Icon from 'app/components/base/Icon';
import RenderPortal from 'app/components/base/RenderPortal';
import classnames from 'classnames';

import style from './style.css';

const ModalWrapper = ({
  header,
  title,
  children,
  shadow,
  rounded,
  stretch,
  nowindow,
  onClickClose
}) => {
  const modifiers = {
    [style['modal--shadow']]: shadow,
    [style['modal--rounded']]: rounded,
    [style['modal--stretch']]: stretch,
    [style['modal--nowindow']]: nowindow
  };

  return (
    <RenderPortal>
      <Layout
        nowrap
        direction="column"
        className={classnames(style.modal, modifiers)}
      >
        <Layout nowrap align="center center" className={style.modal__wrapper}>
          <div className={style.modal__overlay} />
          <div className={style.modal__content}>
            <Layout
              nowrap
              size="noshrink"
              direction="column"
              className={style.modal__window}
            >
              {header && (
                <Layout
                  nowrap
                  align="start start"
                  direction="row"
                  size="noshrink"
                  className={style.modal__header}>
                  {title && (
                    <Flex>
                      <h2 className={style.modal__title}>{title}</h2>
                    </Flex>
                  )}
                  <Button
                    clear
                    stretch
                    freeWidth
                    transparent
                    onClick={onClickClose}
                    className={style.modal__close}
                  >
                    <Icon name="close" className={style.icon__close} />
                  </Button>
                </Layout>
              )}
              {children}
            </Layout>
          </div>
        </Layout>
      </Layout>
    </RenderPortal>
  );
};

// TODO: move to Flow types
// ModalWrapper.propTypes = {
//   header: PropTypes.bool,
//   title: PropTypes.string,
//   children: PropTypes.node,
//   shadow: PropTypes.bool,
//   rounded: PropTypes.bool,
//   stretch: PropTypes.bool,
//   nowindow: PropTypes.bool,
//   onClickClose: PropTypes.bool
// };

export default ModalWrapper;
